<template>
  <section class="notices card !bg-beige-40 text-article">
    <h3 class="title">{{ $t('product_notice_items') }}</h3>
    <p v-if="props.product?.notices" class="py-4 whitespace-pre-wrap" v-html="props.product?.notices"></p>
    <nd-collapse class="!px-0" :list="noticeCollapseData" divider>
      <template #content="{ item }">
        <div class="flex flex-col content-wrapper text-base pb-4">
          <p v-if="item.content" class="whitespace-pre-wrap" v-html="item.content"></p>
          <div v-else class="cancel-and-reschedule">
            <h4>{{ $t('cancellation_policy') }}</h4>
            <ol>
              <li v-for="c in item.cancelRules" :key="c">{{ c }}</li>
            </ol>
            <h4>{{ $t('reschedule_policy') }}</h4>
            <ol>
              <li v-for="r in item.rescheduleRules" :key="r">{{ r }}</li>
            </ol>
          </div>
        </div>
      </template>
    </nd-collapse>
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()

const { t } = useI18n()

const noticeCollapseData = computed(() => {
  if (!props.product) return []

  return [
    {
      title: t('customer_must_know'),
      content: props.product.need_to_know,
    },
    {
      title: t('cancel_change_time_policy'),
      cancelRules: props.product.cancel_rules,
      rescheduleRules: props.product.reschedule_rules,
      custom: true,
    },
  ]
})
</script>

<style lang="scss" scoped></style>
